import 'phaser'
import { deathPunch } from '../demo/deathPunch-sidecar'
import { perf } from '../engine/perf-sidecar'
import { common } from './common-sidecar'
import { preloader } from './preloader-sidecar'

const w = window.innerWidth
const h = window.innerHeight
export const config = {
  type: Phaser.AUTO,
  mode: Phaser.NONE,
  backgroundColor: '#125555',
  width: w,
  height: h,
  scene: {
    preload: preload,
    create: create,
    update: update,
    pack: {
      files: [
        // {
        //   type: 'scenePlugin',
        //   key: 'SpinePlugin',
        //   url: 'plugins/SpinePlugin.js',
        //   sceneKey: 'spine',
        // },
      ],
    },
  },
  parent: 'phaser-root',
  pixelArt: true,
  input: {
    gamepad: false,
  },
}

export const game = new Phaser.Game(config)

window.addEventListener(
  'resize',
  (event) => {
    game.scale.resize(window.innerWidth, window.innerHeight)
  },
  false,
)

function preload() {
  let load = this.load
  perf.mark('preload')
  preloader.preloadAssets(this.load)
}

function create() {
  perf.mark('preload done')
  game.canvas.oncontextmenu = (ev) => {
    ev.preventDefault()
  }
  common.setPhaserScene(this)
  deathPunch.create()
}

function update(time: number, delta: number) {
  perf.updateTimingStart()
  common.setUpdateDelta(delta / 1000)
  deathPunch.update()
}
